import PropTypes from 'prop-types';
/*
 * PropTypes
 *  columnConfig:
 *    [column_key]: {
 *      getter: function(row), used to retrieve unformatted value from row data
 *      formatter: function(value), accepts the value from the getter function,
 *                   returns formatted cell value to be shown to user
 *      isVisible: boolean, whether the column is visible by default
 *      sortOrder: number, represents the initial display order for columns
 *                  (can be inferred from definition order)
 *      filterComponent: string/react component, the component used to filter
 *                        the column
 *    }
 *
 */

const columnConfigShape = PropTypes.shape({
	getter: PropTypes.func.isRequired,
	formatter: PropTypes.func.isRequired,
	filterComponent: PropTypes.any,
	sortOrder: PropTypes.number,
	isVisible: PropTypes.bool,
	isPersisted: PropTypes.bool,
});

export const columnConfigPropType = (props, propName, componentName) => {
	Object.keys(props.columnConfig).map((key) =>
		PropTypes.checkPropTypes(
			{ [key]: columnConfigShape },
			props.columnConfig[key],
			'prop',
			`${componentName} columnConfig`
		)
	);
};

export const SortPropType = PropTypes.shape({
	key: PropTypes.string,
	direction: PropTypes.oneOf(['asc', 'desc']),
});

export const SortsPropType = PropTypes.arrayOf(SortPropType);
